module.exports = __webpack_public_path__ + "img/support_e5.95f5a637.png";